export default __webpack_public_path__ + "static/media/CustomerLogin_bg.2e8e2c52.jpg";